// extracted by mini-css-extract-plugin
export default {"sticky":"style_sticky__3xlOf","btnItem":"style_btnItem__LF7eA","btnGroup":"style_btnGroup__1cJTr","btnBack":"style_btnBack__2j3_z"};